import { createSelector } from '@reduxjs/toolkit';
import { computersForMap } from './computers-for-map';
import { personalDataItemsForMap } from './personal-data-items-for-map';
import { getOrganization } from '../organization/getOrganization';
import type { ContractViewModel } from '@trinnvis/dabih-api-client';
import { flatMap } from '../utilities/flatMap';
import { toList } from '../toList';

export const contractMenuItemsForComputerMap = createSelector(
  computersForMap,
  personalDataItemsForMap,
  getOrganization,
  (computersForMap, personalDataItemsForMap, o) => {
    const r: { [key: string]: ContractViewModel } = {};

    if (o === undefined) return r;

    flatMap(computersForMap, function (e) {
      if (e.serviceProviderContract) {
        return [e.serviceProviderContract];
      } else {
        return [];
      }
    }).forEach(function (e) {
      r[e] = o.contractsById[e];
    });

    flatMap(personalDataItemsForMap, function (e) {
      return e.consentContracts ?? [];
    }).forEach(function (e) {
      r[e] = o.contractsById[e];
    });

    flatMap(personalDataItemsForMap, function (e) {
      if (e.sharedMedicalRecords) {
        return e.sharedMedicalRecordsContracts ?? [];
      } else {
        return [];
      }
    }).forEach(function (e) {
      r[e] = o.contractsById[e];
    });

    return toList(r).map(function (e) {
      return Object.assign({}, e, { pages: [20] });
    });
  },
);
